import { c as _c } from "react/compiler-runtime";
import type { JobComponent, SubtemplateConfig } from "@repo/design-system/lib/client-registry";
import type { Job } from "~/types/job";
import About from "../about/about-eon";
import ApplicationProcess from "../application-process/application-process-eon";
import Benefits from "../benefits/benefits-eon";
import BreadcrumbEon from "../breadcrumb/breadcrumb-eon";
import Company from "../company/company-eon";
import Contact from "../contact/contact-eon";
import Diversity from "../diversity/diversity-eon";
import ExperienceReports from "../experience-reports/experience-reports-eon";
import HeaderImageJobad from "../headerimage/headerimage-jobad-eon";
import JobAdTemplate from "../jobadtemplate/jobad-template-eon";
import JobSharing from "../jobsharing/jobsharing-eon";
import LocationVideo from "../location-video/location-video-eon";
import PrintViewDefault from "../printview/printview-default/printview-eon-default";
import SectionBar from "../sectionbar/sectionbar-eon";
import SimilarJobs from "../similarjobs/similar-jobs-eon";
import StickyApplyBar from "../sticky-apply-bar/sticky-apply-bar-eon";
import StickyContact from "../sticky-contact/sticky-contact-eon";

// Base section component mapping (eon client)
// Subclients can ADD new sections or OVERRIDE these via config.overrides
const BASE_SECTIONS: Record<string, JobComponent<Job>> = {
  headerImage: HeaderImageJobad,
  sectionBar: SectionBar,
  breadcrumb: BreadcrumbEon,
  companyInfo: Company,
  jobSharing: JobSharing,
  jobDescription: JobAdTemplate,
  contact: Contact,
  applicationProcess: ApplicationProcess,
  diversity: Diversity,
  experienceReports: ExperienceReports,
  locationVideo: LocationVideo,
  about: About,
  benefits: Benefits,
  similarJobs: SimilarJobs,
  stickyApplyBar: StickyApplyBar,
  stickyContact: StickyContact,
  printView: PrintViewDefault
};

// Type for section keys - includes base + any string for extensibility
export type SectionKey = keyof typeof BASE_SECTIONS | (string & {});
export function UnifiedJobPageTemplate(t0) {
  const $ = _c(10);
  const {
    job,
    config
  } = t0;
  if (!config) {
    throw new Error("Forgot to pass valid config to UnifiedJobPageTemplate");
  }
  let t1;
  if ($[0] !== config?.overrides) {
    t1 = config?.overrides ?? {};
    $[0] = config?.overrides;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const overrides = t1;
  let sections;
  if ($[2] !== overrides) {
    sections = {
      ...BASE_SECTIONS
    };
    for (const [key, component] of Object.entries(overrides)) {
      if (component) {
        sections[key] = component as JobComponent<Job>;
      }
    }
    $[2] = overrides;
    $[3] = sections;
  } else {
    sections = $[3];
  }
  let t2;
  if ($[4] !== config || $[5] !== job || $[6] !== sections) {
    t2 = config.sections.map(sectionKey => {
      const SectionComponent = sections[sectionKey];
      if (!SectionComponent) {
        return null;
      }
      return <SectionComponent config={config} job={job} key={sectionKey} />;
    });
    $[4] = config;
    $[5] = job;
    $[6] = sections;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <>{t2}</>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}